import { apiGet, apiPost } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
  getNotification: (size=10, current=1) => apiGet(domainUrl(`/v1/notifications/?limit=${size}&page=${current}`)),
  getNotificationCount: (isRead) => apiGet(domainUrl(`/v1/notifications/count`)),
  markAllAsRead: () => apiPost(domainUrl(`/v1/notifications/read-all`)),
};
